"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const utils_1 = require("utils");
function ClientError() {
    const location = (0, react_router_dom_1.useLocation)();
    const { search } = location;
    const query = (0, utils_1.parseQuery)(search);
    const application = query[config_1.QUERY_KEY.APPLICATION];
    let ErrorReportingComponent;
    switch (query[config_1.QUERY_KEY.STATUS]) {
        case config_1.ERROR_STATUS.API_DOWN:
            ErrorReportingComponent = ApiDownError;
            break;
        case config_1.ERROR_STATUS.FORBIDDEN:
        case config_1.ERROR_STATUS.UNAUTHORIZED:
            ErrorReportingComponent = AuthorizationError;
            break;
        case config_1.ERROR_STATUS.NOT_FOUND:
            ErrorReportingComponent = NotFoundError;
            break;
        default:
            throw new Error('Unknown client error');
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-container centered-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-page-container", children: [(0, jsx_runtime_1.jsx)(Error_1.default, { style: { fontSize: 100 }, color: "disabled" }), (0, jsx_runtime_1.jsx)(ErrorReportingComponent, { app: application })] }) }));
}
exports.default = (0, react_1.memo)(ClientError);
function ApiDownError() {
    const history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Network Unavailable" }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: "The network is unavailable. Please retry your request again." }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: () => history.goBack(), children: "Retry Request" })] }));
}
// Authorization errors will be handled only for applications that require
// login...
function AuthorizationError({ app }) {
    const history = (0, react_router_dom_1.useHistory)();
    const handleRedirect = () => {
        history.push(app === 'credit-portal' ? config_1.CREDIT_PORTAL_URL : config_1.MERCHANT_PORTAL_URL);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Unauthorized Request" }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: "You are unauthorized. Please re-login and try your request again." }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: handleRedirect, children: "Logout and Retry" })] }));
}
function NotFoundError() {
    const history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Unknown Page Error" }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: "Oops there appears to be a problem. The page you requested doesn\u2019t exist. If you believe this is an error please contact us." }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: () => history.goBack(), children: "Go Back" })] }));
}
